import { SelectControlEntityValueItem } from '../../../../../Select'

function ViewingFormSlotPickerValue({ value, ...restProps }) {
  return (
    <SelectControlEntityValueItem
      {...restProps}
      value={{ ...value, label: value.valueLabel }}
    />
  )
}

export default ViewingFormSlotPickerValue
